import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { MolduraDeAutenticacao } from '@titularis/ui';
import { registrarTela } from '../analytics';

/**
 * As telas de autenticação do aluno, dentro da moldura comum.
 *
 * A moldura subiu para o `packages/ui` porque o backoffice usa a mesma: são
 * duas portas do mesmo produto, com a mesma identidade e o mesmo cookie. Aqui
 * sobra só o encaixe com o roteador - e a contagem de tela.
 *
 * **A contagem mora aqui, e não em cada página.** O funil ia de `cta_clicked`,
 * na landing, direto para `signup_completed`, no servidor: as cinco telas de
 * autenticação não registravam nada, e sem o degrau do meio "o canal não traz
 * ninguém" e "o formulário derruba todo mundo" eram a mesma leitura - com
 * trabalhos opostos do outro lado. Cinco `useEffect` iguais seriam cinco
 * lugares para esquecer o sexto; a moldura é por onde todos passam, e a tela
 * nova nasce medida.
 *
 * O token de `/nova-senha` não escapa por aqui: o `registrarTela` monta a URL a
 * partir do caminho e só deixa passar os parâmetros de campanha da lista de
 * permissão dele.
 */
export function AuthLayout() {
  const { pathname } = useLocation();

  useEffect(() => registrarTela(pathname), [pathname]);

  return (
    <MolduraDeAutenticacao>
      <Outlet />
    </MolduraDeAutenticacao>
  );
}
